const INITIAL_STATE = {
    status: 'done',
    errors: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'NEWSLETTER_STATUS':
            return { ...state, status: action.payload }
        case 'NEWSLETTER_ERRORS':
            return { ...state, errors: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/newsletterReducer.js